// extracted by mini-css-extract-plugin
export default {"vertical-icon":"RoleCard_vertical-icon__n52hx"};